(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-page-help"] && !Shopify.designMode) return;
  try {
    
// Prepend topic to message body on submit
(function() {
  var form = document.getElementById('help-contact-form');
  if (!form) return;
  form.addEventListener('submit', function() {
    var topicEl = document.getElementById('contact-topic');
    var bodyEl  = document.getElementById('contact-message');
    if (!topicEl || !bodyEl) return;
    var topic = topicEl.value;
    if (topic) {
      bodyEl.value = 'Topic: ' + topic + '\n\n' + bodyEl.value;
    }
  });
})();

// Smooth scroll for browse FAQs link
document.querySelector('a[href="#faq"]')?.addEventListener('click', function(e) {
  e.preventDefault();
  document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-pdp-klaviyo-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var target = document.getElementById('klv-review-target');

  /* ── Hide "Customer reviews" heading injected by Klaviyo ── */
  function hideKlaviyoHeading() {
    document.querySelectorAll('.klaviyo-product-review-widget').forEach(function (widget) {
      var headings = widget.querySelectorAll('h2, h3');
      headings.forEach(function (h) {
        var text = h.textContent.trim().toLowerCase();
        if (text === 'customer reviews' || text === 'reviews') {
          h.style.setProperty('display', 'none', 'important');
        }
      });
    });
  }

  if (!target) {
    // Still hide headings even if no target div
    var ho = new MutationObserver(hideKlaviyoHeading);
    ho.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { hideKlaviyoHeading(); ho.disconnect(); }, 5000);
    return;
  }

  /* ── Move Klaviyo's auto-injected widget into our target div ── */
  function grabExistingWidget() {
    var all = document.querySelectorAll('.klaviyo-product-review-widget');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el !== target && el.children.length > 0) {
        while (el.firstChild) {
          target.appendChild(el.firstChild);
        }
        el.style.display = 'none';
        hideKlaviyoHeading();
        return true;
      }
    }
    return false;
  }

  /* ── Watch for Klaviyo to inject the widget anywhere on the page ── */
  var observer = new MutationObserver(function () {
    hideKlaviyoHeading();
    if (grabExistingWidget()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Try immediately in case it already rendered before this script ran
  hideKlaviyoHeading();
  if (!grabExistingWidget()) {
    setTimeout(function () {
      grabExistingWidget();
      hideKlaviyoHeading();
      observer.disconnect();
    }, 5000);
  } else {
    observer.disconnect();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dataEl = document.getElementById('sl-data');
    var mapEl  = document.getElementById('sl-map');
    if (!dataEl || !mapEl) return;

    var STORES = [];
    try { STORES = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var listEl   = document.getElementById('sl-list');
    var emptyEl  = document.getElementById('sl-empty');
    var searchEl = document.getElementById('sl-search');
    var countEl  = document.getElementById('sl-count');
    var totalEl  = document.getElementById('sl-total');
    var geoBtn   = document.getElementById('sl-geo');
    var chipsEl  = document.getElementById('sl-chips');

    if (totalEl) totalEl.textContent = STORES.length;

    var state = { q: '', boro: '', userLatLng: null };
    var markers = [];
    var map, cluster;

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function haversine(a, b, c, d) {
      var R = 3958.8, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
    }

    function dirUrl(s) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng;
    }

    function waitForLeaflet(cb, tries) {
      tries = tries || 0;
      if (window.L && window.L.map) return cb();
      if (tries > 100) return;
      setTimeout(function () { waitForLeaflet(cb, tries + 1); }, 50);
    }

    waitForLeaflet(initMap);

    function initMap() {
      map = L.map(mapEl, { preferCanvas: true, scrollWheelZoom: true, zoomControl: true })
            .setView([40.7128, -73.96], 12);

      var cartoKey = mapEl.dataset.cartoKey;
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png' + (cartoKey ? '?key=' + encodeURIComponent(cartoKey) : ''), {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd', maxZoom: 19
      }).addTo(map);

      STORES.forEach(function (s, i) {
        s._i = i;
        var m = L.circleMarker([s.lat, s.lng], {
          radius: 7, fillColor: '#204c3e', color: '#fff',
          weight: 2, fillOpacity: 1
        }).addTo(map);
        m.bindPopup(
          '<p class="sl-popup-name">' + esc(s.name) + '</p>' +
          '<p class="sl-popup-addr">' + esc(s.address) + ', ' + esc(s.borough) + ' ' + esc(s.zip) + '</p>' +
          '<a class="sl-popup-dir" href="' + dirUrl(s) + '" target="_blank" rel="noopener">Get directions &rsaquo;</a>'
        );
        m.on('click', function () { selectStore(i, false); });
        markers[i] = m;
      });

      render();
    }

    function setMarkerActive(i, on) {
      var m = markers[i];
      if (!m) return;
      m.setStyle(on
        ? { radius: 10, fillColor: '#fb9918', color: '#fff', weight: 2.5 }
        : { radius: 7, fillColor: '#204c3e', color: '#fff', weight: 2 });
      if (on && m.bringToFront) m.bringToFront();
    }

    var activeIdx = null;
    function selectStore(i, fromList) {
      if (activeIdx !== null) setMarkerActive(activeIdx, false);
      activeIdx = i;
      setMarkerActive(i, true);
      var s = STORES[i];
      if (map) { map.flyTo([s.lat, s.lng], 15, { duration: 0.6 }); }
      if (markers[i]) markers[i].openPopup();

      document.querySelectorAll('.sl-item').forEach(function (el) {
        el.classList.toggle('sl-item--active', +el.dataset.i === i);
      });
      if (!fromList) {
        var row = listEl.querySelector('.sl-item[data-i="' + i + '"]');
        if (row) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    function filtered() {
      var q = state.q.trim().toLowerCase();
      var out = STORES.filter(function (s) {
        if (state.boro && s.borough !== state.boro) return false;
        if (!q) return true;
        return (s.name + ' ' + s.address + ' ' + s.zip + ' ' + s.borough).toLowerCase().indexOf(q) > -1;
      });
      if (state.userLatLng) {
        out.forEach(function (s) {
          s._dist = haversine(state.userLatLng[0], state.userLatLng[1], s.lat, s.lng);
        });
        out.sort(function (a, b) { return a._dist - b._dist; });
      }
      return out;
    }

    /* Show only the filtered stores' pins on the map (hide the rest) */
    function syncMarkers(rows) {
      if (!map) return;
      var visible = {};
      rows.forEach(function (s) { visible[s._i] = true; });
      markers.forEach(function (m, i) {
        if (!m) return;
        if (visible[i]) {
          if (!map.hasLayer(m)) map.addLayer(m);
        } else if (map.hasLayer(m)) {
          map.removeLayer(m);
        }
      });
    }

    function render() {
      var rows = filtered();
      syncMarkers(rows);
      countEl.textContent = rows.length;
      listEl.innerHTML = '';
      emptyEl.hidden = rows.length > 0;

      rows.forEach(function (s, n) {
        var div = document.createElement('div');
        div.className = 'sl-item';
        div.dataset.i = s._i;
        var dist = (s._dist != null) ? '<span class="sl-item-dist">' + s._dist.toFixed(1) + ' mi</span>' : '';
        div.innerHTML =
          '<span class="sl-item-num">' + (n + 1) + '</span>' +
          '<div class="sl-item-body">' +
            '<p class="sl-item-name">' + esc(s.name) + '</p>' +
            '<p class="sl-item-addr">' + esc(s.address) + ', ' + esc(s.borough) + ' ' + esc(s.zip) + '</p>' +
            '<div class="sl-item-meta"><span class="sl-item-boro">' + esc(s.borough) + '</span>' + dist + '</div>' +
            '<a class="sl-item-dir" href="' + dirUrl(s) + '" target="_blank" rel="noopener">Get directions</a>' +
          '</div>';
        div.addEventListener('click', function (e) {
          if (e.target.closest('.sl-item-dir')) return;
          selectStore(s._i, true);
        });
        listEl.appendChild(div);
      });
    }

    /* Search */
    var t;
    searchEl.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () { state.q = searchEl.value; render(); }, 120);
    });

    /* Borough chips */
    chipsEl.addEventListener('click', function (e) {
      var chip = e.target.closest('.sl-chip');
      if (!chip) return;
      state.boro = chip.dataset.boro;
      chipsEl.querySelectorAll('.sl-chip').forEach(function (c) {
        c.classList.toggle('sl-chip--on', c === chip);
      });
      render();
      if (map) {
        var pts = filtered().map(function (s) { return [s.lat, s.lng]; });
        if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 14 });
      }
    });

    /* Geolocation */
    geoBtn.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      geoBtn.classList.add('loading');
      navigator.geolocation.getCurrentPosition(function (pos) {
        geoBtn.classList.remove('loading');
        state.userLatLng = [pos.coords.latitude, pos.coords.longitude];
        render();
        if (map) {
          L.circleMarker(state.userLatLng, {
            radius: 8, fillColor: '#2f80ed', color: '#fff', weight: 3, fillOpacity: 1
          }).addTo(map).bindPopup('You are here');
          map.setView(state.userLatLng, 13);
        }
      }, function () {
        geoBtn.classList.remove('loading');
        geoBtn.textContent = 'location unavailable';
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
